import axios from "../../../../axios";
import React from "react";
import "./edit_deletePost.css";
import { useSelector } from "react-redux";

const DeletePost = ({ setDelet1, communityId, post_id }) => {
  // const [postDeleted, setPostDeleted] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  const handelDeletePost = async () => {
    try {
      let res = await axios.delete(
        `/community/${communityId}/post/delete/${post_id}`,
        {
          data: { user_id: currentUser?.id },
        }
      );
      res && window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className=" delete_post_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className=" delete_post_close_btn"
          alt=""
          onClick={(e) => setDelet1(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_post_container shadow">
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mt-4 mb-5 delete_post_text">
              Are you sure you want to delete Post ?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                className="btn btn-danger col-sm-5  post_delete_btn"
                onClick={handelDeletePost}
              >
                Yes
              </button>
              <button
                className="btn btn-danger col-sm-5 post_delete_btn no"
                autoFocus
                onClick={(e) => setDelet1(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeletePost;
